"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Opacity = void 0;
var Opacity;
(function (Opacity) {
    Opacity["Transparent"] = "u-transparent";
    Opacity["Translucent"] = "u-translucent";
    Opacity["Opaque"] = "u-opaque";
})(Opacity = exports.Opacity || (exports.Opacity = {}));
//# sourceMappingURL=Opacity.js.map